import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Badge } from '../../material-ui/Badge';
import { ListItem, ListItemIcon, ListItemText } from '../../material-ui/List';
import { Document } from '../../../icons';
import { useDocumentCounts } from '../../../selectors/documents';
import { useStyles } from './useStyles';

export const DocumentAdapter = memo(({ value, selected, onClick, className }) => {
    const { count, notDownloaded } = useDocumentCounts();

    const { t: translate } = useTranslation();
    const classes = useStyles();

    const handleClick = useCallback(() => onClick(value), [onClick]);

    return (
        <ListItem onClick={handleClick} button={true} disabled={count === 0} selected={selected}>
            <ListItemIcon className={classes.listIcon}>
                <Badge
                    badgeContent={notDownloaded}
                    color="secondary"
                    max={999}
                    classes={{ anchorOriginTopRightRectangular: classes.badge }}
                >
                    <Document width="24" height="24" />
                </Badge>
            </ListItemIcon>
            <ListItemText primary={translate('labels.documents')} className={className} />
        </ListItem>
    );
});

DocumentAdapter.displayName = 'DocumentAdapter';
